import SiteCard from '@/components/feature/SiteCard';
import { navSites, siteCategories } from '@/mocks/navigation';

export default function HotPicks() {
  const categoryName = (id: string) => siteCategories.find((item) => item.id === id)?.name ?? '';

  const ranking = [...navSites].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section id="ranking" aria-labelledby="ranking-title" className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <span className="font-label text-xs tracking-[0.2em] text-primary-600">RANKING</span>
          <h2 id="ranking-title" className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门站点榜
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            综合公开讨论量与近一周的更新频率排序，每天刷新一次。榜单不接受付费置顶。
          </p>
        </div>
        <p className="flex items-center gap-2 font-label text-xs text-foreground-500">
          <i className="ri-refresh-line text-secondary-600" aria-hidden="true"></i>
          数据更新于 2026-09-10
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5">
        {ranking.map((site, index) => (
          <SiteCard key={site.id} site={site} categoryName={categoryName(site.category)} rank={index + 1} />
        ))}
      </div>
    </section>
  );
}